module.exports = __webpack_public_path__ + "static/img/guangzhou3.d55b5c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/guangzhou3.jpg
// module id = SCOV
// module chunks = 1